module.exports = __webpack_public_path__ + "static/azure-08f5d56e9373fd4a7bb3aad790d24bf2.png";